import api from './api';
const token = localStorage.getItem('ownerToken');

export const getSubscribers = async (restaurantId) => {
  const response = await api.get(`/restaurants/${restaurantId}/subscribers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(response);
  return response.data;
};

// const token = localStorage.getItem('ownerToken');

// const response = await api.get('/customers/subscriptions', {
//   headers: {
//     Authorization: `Bearer ${token}`, // Correctly set the Authorization header
//   },
// });

export const deleteSubscriber = async (restaurantId, subscriberId) => {
  const response = await api.delete(
    `/restaurants/${restaurantId}/subscribers/${subscriberId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const unsubscribe = (restaurantId) => {
  return api.post(`/subscriptions/unsubscribe/${restaurantId}`);
};
